/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Icon from 'material/graphic/icon/icon';
import ToolTip from 'material/message/tooltip/tooltip';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/organize/toggle/toggle_styles';



/* ========== ~~~~~~~~~~ EMBED : DELETE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Toggle extends Component {
    handleClick = () => {
        this.props.live ? this.props.toggleMethods.liveToNotLive(this.props.index) : this.props.toggleMethods.notLiveToLive(this.props.index);
    }
    renderSymbol() {
        return this.props.live ? <Icon name={`times-circle`} klass={`remove`} /> : <Icon name={`plus-circle`} klass={`add`} />;
    }
    render() {
        return (
            <ToolTip position={`top`} action={`mouseenter`} content={this.props.live ? 'Remove from Embed' : 'Add to Embed'}>
                <div className={`toggle ${this.props.classes.toggle} ${this.props.position}`} onClick={this.handleClick} >
                    {this.renderSymbol()}
                </div>
            </ToolTip>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(Toggle);